import { Component, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { InfoDropdown, FaqBuilder } from 'src/app/components/faq/faq.component';
import { FeatureType } from 'src/app/components/featured-plates/featured-plates.component';

@Component({
  selector: 'pla-buy-landing',
  templateUrl: './buy-landing.component.html',
  styleUrls: ['./buy-landing.component.scss'],
})
export class BuyLandingComponent implements OnInit {
  public searchTrigger: EventEmitter<void> = new EventEmitter<void>();
  public plateViewerPlate: string = '';
  public xmasFeatured = new FeatureType('🎅🏼 Christmas Number Plates 🎄', 'x-mas');
  public meFeatured = new FeatureType(
    'Most Expensive Plates',
    'most-expensive'
  );

  public cards: any[] = [
    {
      image: 'https://cdn.platex.co.uk/pages/landing/platex_needle_haystack.png',
      number: '01',
      title: 'SEARCH ANYTHING',
      header: `It's easy when you know how`,
      body: `Industry leading smart search scours the whole market in seconds.`,
      link: 'Find your needle',
      url: '/buy',
    },
    {
      image: 'https://cdn.platex.co.uk/pages/landing/platex_compare_result_view.png',
      number: '02',
      title: 'COMPARE DEALS',
      header: `See all deals and save`,
      body: 'Compare private plate deals from across the market and save £££',
      link: 'Plate Compare',
      url: '/',
    },
    {
      image: 'https://cdn.platex.co.uk/pages/landing/mac_dealer_link.png',
      number: '03',
      title: 'CHECKOUT',
      header: `Checkout directly with the dealer`,
      body: 'Choose the extras you wish such as perspex plates or to split payments with finance',
      link: 'Get Started',
      url: '/buy',
    },
    // { image: 'https://cdn.platex.co.uk/pages/landing/price-comparison.png', title: 'PRICE COMPARISON', header: `See all deals and save`, body: 'Compare private plate deals from 40+ dealers and save £££', link: 'Plate Compare', url: '/compare' },
    // { image: 'https://cdn.platex.co.uk/pages/landing/urus-plate.png', title: 'SELL YOUR PLATE', header: `Commission Free Sales`, body: 'Our advanced search ensures your registration is seen by the right buyers more often.', link: 'Get it listed', url: '/sell' },
  ];

  constructor(private router: Router) { }

  ngOnInit(): void { }

  public OpenPlateViewerWithCar(car: string): void {
    if (this.plateViewerPlate != null)
      this.router.navigate([
        `/plate-viewer/car/${car}/${this.plateViewerPlate}`,
      ]);
    else this.router.navigate([`/plate-viewer/car/${car}`]);
  }

  public OpenPlateViewerWithPlate(): void {
    this.router.navigate([`/plate-viewer/plate/${this.plateViewerPlate}`]);
  }
}
